<template>
  <div class="nq5c-zt">
    <div class="fullPage" id="page" ref="fullPage">
      <!-- <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer" @mousewheel="mouseWheel"
        @touchstart="getTouchstartY()" @touchend="touchmove()" @touchmove.prevent> -->

      <!-- PC端浮动留资 mob端右侧按钮浮动 -->
      <div v-if="!isPortrait" class="oneform" :class="{ 'animate': isAnimating }">
        <el-form :inline="true">

          <el-form-item class="inbox">
            <el-select popper-class="my-select-style" class="inboxinput" v-model="formInline.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries">
              <el-option v-for="(item, key) in (carAlldata ? carAlldata.series : [])" :key="key" :value="item.cmsid"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select popper-class="my-select-style" class="inboxinput" v-model="formInline.Province" placeholder="选择省份" @change="setProvince">
              <el-option v-for="(item, key) in (alldata ? alldata.province : [])" :value="item.id" :key="key"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select popper-class="my-select-style" class="inboxinput" v-model="formInline.City" placeholder="选择城市" no-data-text="无" @click="setCity()"
              code-stm="event, PAGEURL, 切换城市信息pc" @change="cityChange">
              <el-option v-for="(item, key) in this.cascadingCities" :value="item.id" :key="key" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox" style="width: calc(248 / 1920 * 100vw);">
            <el-form-item>
              <!-- <el-select class="inboxinput" v-model="formInline.DealerCode" placeholder="经销商" @change="dealerChange">
                <el-option v-for="(item, key) in this.cascadingDealers" :key="key" :value="item.code"
                  :label="item.name"></el-option>
              </el-select> -->
              <el-select
                class="inboxinput"
                v-model="formInline.DealerCode"
                placeholder="请选择经销商"
                no-data-text="无"
                @change="dealerChange"
                popper-class="select-option-dealer my-select-style"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                  :disabled="item.isDisabled"
                >
                <template #default>
                  <div  style="display: flex;align-items: start;padding: 5px 0;">
                    <i v-if="formInline.DealerCode == item.code" class="el-icon-check" style="padding-top: 10px;font-weight: 700;"></i>
                    <div v-else style="width: 14px;height: 14px;"></div>
                    <div style="padding-left: 10px;" >
                      <div>{{ item.name }}</div>
                      <div style="color: rgba(180, 183, 192, 1);font-size: 12px;line-height: 20px;">{{ item.address }}</div>
                    </div>
                  </div>
                </template>
              </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item class="inbox">
            <el-input class="inboxinput" v-model="formInline.Name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item class="inbox">
            <el-input class="inboxinput" v-model="formInline.Phone" placeholder="电话"></el-input>
          </el-form-item>
          <el-form-item  class="inbox">
            <el-input
              placeholder="验证码"
              class="inboxinput"
              v-model="formInline.verificationCode"
              maxlength="6"
              oninput="if(value.length > 6) value=value.slice(0, 6)">
              <template slot="append">
                <el-button
                  class="button"
                  @click="handleCaptchaButtonClick('main')"
                  code-stm="event, PAGEURL, 获取验证码mob"
                  :class="{ disabled: !this.countDownCanClick }"
                  :disabled="!this.countDownCanClick"
                  style="padding:0 3px;width:calc(90 / 1920 * 100vw);height:40px;font-size:calc(14 / 1920 * 100vw);background: #fff;border-radius: 0;border-top: 1px solid #DDDFE5;border-bottom: 1px solid #DDDFE5;color:#000"
                  >{{ countDownContent }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: auto !important;">
            <el-checkbox v-model="formInline.checked" className="agreement-checkbox" @change="checkboxChange"
              style="display: flex;justify-content: center;align-items: center;">
                <!-- <span class="tips">
                  我同意起亚及合作商就购买新车<br />事宜与我联系我同意提供电话号码
                </span> -->
                <span class="tips" style="color: #05141F99;white-space: nowrap;">
                已阅读并同意
                <span  style="text-decoration: underline;color: #05141F;white-space: nowrap;" @click="read" code-stm="event, PAGEURL, 隐私协议">
                  《隐私协议》
                </span>，
                <br />且同意起亚经销商与我联系。
              </span>
            </el-checkbox>
          </el-form-item>
          <el-form-item class="" style="margin-bottom: auto !important;">
            <el-button type="primary" @click="submitInformation"
              style="background-color: #000;color: #fff;border: none;" code-ga="event, PAGEURL, 悬浮提交按钮点击"
              code-stm="event, PAGEURL, 悬浮提交按钮点击">提 交</el-button>
          </el-form-item>
        </el-form>

      </div>
      <div id="captcha-element1"></div>
        <!-- 隐藏的验证码触发按钮，用于共享验证码实例 -->
        <button id="captcha-trigger-button" style="display: none;"></button>
      <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer"></div>
      <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer">
       <!-- <MobButton v-if="isPortrait"></MobButton> -->
        <Header @forbid="forbid" @open="open" />
        <ShareBar></ShareBar>
        <!-- kv -->
        <OnepageAW />
        
        <Slice1 />
        <div id="page5" class="section" style="margin-top: -1px;" ref="pc-block5" :class="isPortrait ? 'section5' : ''">
          <!-- <FivepageAW /> -->
          <MyFormPc ref="myFormPc" :clientPosition="clientPosition" v-if="!isPortrait" />
          <MyFormMob ref="myFormMob" :clientPosition="clientPosition" v-if="isPortrait" />
        </div>
        <div id="page1" class="section section6" ref="footer">
          <Footer />
        </div>
      </div>
      <div v-if="isPortrait" class="yy-box" style="position: fixed;bottom: 50px;z-index: 200;">
        <div class="yy-box-btn" id="book-button" >
          <button v-show="showTopBtn" ref="bookRef" @click="gotoBlock(5)">预约试驾</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MobButton from "@/components/Mob-Button";
import Header from "@/components/Header-co";
import OnepageAW from "@/components/aw2025/Onepage-AW";
import Slice1 from "@/components/aw2025/Slice1";
import MyFormPc from '@/components/aw2025/My-Form-pc'
import MyFormMob from '@/components/aw2025/My-Form-mob'
import Footer from "@/components/Footer-co";
import ShareBar from "@/components/ShareBar-co";
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
import { isPortraitFun, getUrlKey, throttle, debounce,filterDealers,filterCarSeries } from "@/utils/utils.js";
import $ from 'jquery'
export default {
  name: 'index',
  components: { Header, OnepageAW, Slice1, Footer, ShareBar, MyFormPc, MyFormMob, MobButton },
  data() {
    return {
      clientPosition: null,
      isPortrait: isPortraitFun(),
      lastTimeStamp: false,
      // minip: false,
      minip2: false,
      startY: 0,
      startX: 0,
      totalPage: 5,
      fullpage: {
        current: 1,
        isScrolling: false,
        deltaY: 0,
      },
      flag: false,
      cHeight: 0,
      isFullVideo: false,
      isAnimating: false,
      formInline: {
        // 车型选项加载完成后再设置默认值，避免 el-select 暂时显示数字 ID
        CarSeriesCMSID: "",
        CarSeriesName: "全新赛图斯",
        // CarModelCMSID: "",
        // CarModelName: "",
        CarModelCMSID: "1686",
        CarModelName: "1.5L IVT 舒适版",

      },
      alldata: null,
      carAlldata: null,
      cascadingCities: [],
      cascadingDealers: [],
      showTopBtn: true,
      page5Height:200,
      page5Top:100,

      totalTime: 60,
      countDownContent: "获取验证码",
      countDownCanClick: true,
      clock: null,
      captcha: null, // 阿里验证码实例
      captchaSource: 'main', // 触发来源：main/myform
    };
  },
  created() {
    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);
        // const codesToKeep =["HD349", "HD328", "HD358", "HD377", "HD356", "HD392", "HD346", "HD355", "HD500", "HD506", "HD511", "HD512", "HD508", "HD507", "HD510", "HD324", "HD314", "HD375"];
        const codesToKeep = [
          "HD349", "HD450", "HD328", "HD201", "XB317", "DB003", "HD358", "XB204", "XB308", "HD377",
          "HD291", "HD356", "XB201", "HD392", "HD407", "HZ340", "HD293", "XN502", "HD256", "XB309",
          "XN503", "HB320", "XB315", "XB303", "HD237", "XB318", "HB025", "HZ216", "DB006", "XB202",
          "HD298", "HD029", "XB207", "HN100", "HN202", "HD244", "HD606", "HB450", "HZ304", "HD115",
          "HB209", "HZ370", "HD346", "HD118", "XN251", "XB321", "HD289", "HD427", "XN423", "HN332",
          "HD608", "HZ441", "DB307", "HD355", "HD248", "HN423", "HD030", "HN333", "HD236", "HD180",
          "XN302", "DB335", "HZ041", "HB018", "XB004", "HB328", "HZ355", "HZ029", "HD500", "HZ042",
          "HZ375", "XB323", "HZ374", "XB224", "HB432", "HN087", "DB326", "XB325", "HD506", "XB305",
          "HZ376", "HD182", "DB336", "HN035", "HN094", "XB401", "DB338", "HD150", "HB462", "HD511",
          "HD512", "HD508", "XN310", "HD507", "HB430", "HB311", "HN092", "HD510", "HD324", "DB026",
          "XB219", "HB433", "HD443", "XN424", "HZ377", "HZ447", "HN076", "HD610", "HB460", "HB529",
          "XN259", "HN103", "XB226", "HB461", "HD181", "HD609", "XB326", "XB324", "HD183", "HD447",
          "XN260", "XN425", "XB227", "DB340", "DB339", "HD314", "HD184", "HD156", "HD375", "HD185",
          "HD028", "HZ371", "HB465", "DB322", "DB005", "HB530", "HB531", "HDA05", "XB312", "XB320",
          "XB329", "XB328", "XB316", "XB327"
        ];
        // filterDealers(res.data, codesToKeep);
        this.alldata = res.data;
        // this.setProvince();
        // this.setCity();


        // this.$axios.get(CSMUrl).then((res1) => {
        //   debugger
        //   this.carAlldata = res1.data;
        //   this.formInline.CarSeriesCMSID="436"
        // });
        fetch(CSMUrl).then(function (response) {
          return response.json();
        }).then((data) => {
          console.log("车型车款数据", data);
          const filtercar = [
            "447","261","330"
          ];
          // filterCarSeries(data,filtercar);
          this.carAlldata = data;
          this.formInline.CarSeriesCMSID = "448";
        });
      });
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.cutLocal()
      }, 2000);

    var browser = {
      versions: function () {
        var u = navigator.userAgent, app = navigator.appVersion;
        return { // 移动终端浏览器版本信息
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // Opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/) && u.indexOf('QIHU') && u.indexOf('Chrome') < 0, // 是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // iOS终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // Android 终端或者 UC 浏览器
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为 iPhone 或者 QQHD 浏览器
          iPad: u.indexOf('iPad') > -1, // 是否 iPad
          webApp: u.indexOf('Safari') == -1, // 是否WEB应该程序，没有头部与底部。
          ua: u
        };
      }(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }
    if (browser.versions.mobile && !browser.versions.iPad) {
      this.cHeight = document.documentElement.clientHeight
      window.addEventListener("resize", this.setResize);
      this.setResize()
    }
    if (navigator.userAgent.indexOf("Firefox") > -1) {
      var that = this;
      document.getElementById("fullPageContainer").addEventListener("DOMMouseScroll", function (e) {
        console.log(e);
        that.mouseWheel(e);
      });
      document.getElementById("fullPageContainer").onmousedown = function (e) {
        that.startX = e.clientX;
        that.startY = e.clientY;
      };
      document.getElementById("fullPageContainer").onmouseup = function (e) {
        if (that.fullpage.isScrolling) {
          return false;
        }
        console.log("touch 123123");
        // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
        // event.preventDefault()
        let endx, endy;
        endx = e.clientX;
        endy = e.clientY;
        let direction = that.getDirection(that.startX, that.startY, endx, endy);
        switch (direction) {
          case 0:
            //alert("未滑动！");
            break;
          case 1:
            //alert("向上！")
            that.next();
            break;
          case 2:
            // alert("向下！")
            that.pre();
            break;
          case 3:
            //alert("向左！")
            break;
          case 4:
            //alert("向右！")
            break;
          default:
        }
      };
    }

    const _that = this
    // if (getUrlKey("minip")) {
    //   this.minip = true
    //   this.totalPage = 5
    // }
    if (getUrlKey("minip") && getUrlKey("minip") == 2) {
      this.minip2 = true;
    }

    document.onkeydown = function (e) {
      const ev = e || window.event;
      if (_that.fullpage.isScrolling) {
        return false;
      }
      switch (ev.keyCode) {
        case 38:
          _that.pre()
          break;
        case 40:
          _that.next()
          break;
        default:
          // console.log("请按上下左右键");
          break;
      }
      // console.log(ev.keyCode);
    }
    window.addEventListener('scroll', this.handleScroll);
    this.page5Height = document.getElementById("page5").offsetHeight
    this.page5Top= document.getElementById("page5").offsetTop
    // 初始化阿里验证
    this.$nextTick(() => {
      this.ensureCaptchaReady();
    });

    //滚出视频区域暂停
    window.addEventListener('scroll', function() {
          const video= document.getElementById("videoPlayerFull")
          const video1= document.getElementById("videoPlayerFull1")
          var vh = window.innerHeight;
          var vw = window.innerWidth;
          if(!_that.isPortrait){//pc
            if(document.getElementById("page2")){
              var pageTopPc= document.getElementById("page2").getBoundingClientRect().top
              console.log(pageTopPc)
              if(pageTopPc <= - 9 / 16 * vw ){
                video.pause()
              }
            }
          }else{//mob
            if(document.getElementById("page2")){
              var pageTopMob= document.getElementById("page2").getBoundingClientRect().top
              // console.log(pageTopPc)
              if(pageTopMob <= - 9 / 10 * vw  ){
                video1.pause()
              }
            }
          }
        })
  },
  methods: {
    // 初始化阿里验证
    ensureCaptchaReady() {
      this.waitForCaptchaElements()
        .then(() => {
          this.initCaptcha();
        })
        .catch((err) => {
          console.warn(err?.message || "captcha elements not ready");
        });
    },
    waitForCaptchaElements(retries = 30, interval = 100) {
      return new Promise((resolve, reject) => {
        const attempt = () => {
          const element = document.querySelector("#captcha-element1");
          const triggerButton = document.querySelector("#captcha-trigger-button");
          if (element && triggerButton) {
            resolve({ element, triggerButton });
            return;
          }
          if (retries <= 0) {
            reject(new Error("captcha elements missing"));
            return;
          }
          retries -= 1;
          window.setTimeout(attempt, interval);
        };
        attempt();
      });
    },
    initCaptcha() {
      const element = document.querySelector("#captcha-element1");
      const triggerButton = document.querySelector("#captcha-trigger-button");
      if (!element || !triggerButton || !window.initAliyunCaptcha) {
        console.warn("captcha element/trigger missing or initAliyunCaptcha undefined");
        return;
      }
      let preText = '';
      if (!window.location.href.includes("https://www.kia.cn")) {
        preText = 'https://uat.kia.cn';
      } else {
        preText = 'https://www.kia.cn';
      }
      const kiaLogoUrl = preText + '/assets/~/media/images/aliyuncaptcha/kia_logo.png';

      window.initAliyunCaptcha({
        SceneId: "nrr27cp0",
        mode: "popup",
        element: "#captcha-element1",
        button: "#captcha-trigger-button",
        captchaLogoImg: kiaLogoUrl,
        success: (captchaVerifyParam) => {
          console.log("captchaVerifyParam", captchaVerifyParam);
          if (this.captchaSource === 'main') {
            this.countDown(captchaVerifyParam);
          } else if (this.captchaSource === 'myform') {
            const myFormComponent = this.$refs.myFormPc || this.$refs.myFormMob;
            if (myFormComponent && typeof myFormComponent.countDown === 'function') {
              myFormComponent.countDown(captchaVerifyParam);
            } else {
              console.warn('MyForm component not found or countDown unavailable');
            }
          }
        },
        fail: function (result) {
          console.error(result);
        },
        getInstance: (instance) => {
          this.captcha = instance;
          window.sharedCaptchaInstance = instance;
        },
        slideStyle: {
          width: 360,
          height: 40,
        },
      });
    },
    handleCaptchaButtonClick(source) {
      this.captchaSource = source;
      const triggerButton = document.querySelector("#captcha-trigger-button");
      if (triggerButton) {
        triggerButton.click();
      }
    },
    countDown(captchaVerifyParam) {
      if (!this.formInline.Phone) {
        this.$message.error("请填写正确的手机号");
        this.initCaptcha();
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.formInline.Phone)) {
        this.$message.error("请填写正确的手机号");
        this.initCaptcha();
        return;
      }
      if (!this.countDownCanClick) return;
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true;
        }
      }, 1000);
      //发送验证码（带阿里验证）
      const getCodeData = {
        phoneNumbers: this.formInline.Phone,
        captchaVerifyParam,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/CaptchaSendVerificationCode`, getCodeData)
        .then((res) => {
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
          this.initCaptcha();
        });
    },
    read() {
      // this.$router.push({
      //   path: "/terms",
      // });
      const route = this.$router.resolve({ path: '/terms' });
      const href = route.href;
      window.open(href, '_blank');
    },
    checkboxChange(e){
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    handleScroll () {
        const scrollTop = (window.scrollY || document.documentElement.scrollTop);
        this.showTopBtn = (scrollTop < this.page5Top-this.page5Height + 200) ;
    },
    // async cutLocal() {
    //   let map = await this.load()
    //   let _this = this
    //   if (map.Map) {
    //     let funL = new map.Geolocation()
    //     funL.getCurrentPosition((res) => {
    //       // 如果存在经纬度
    //       if (res.point) {
    //         var myGeo = new map.Geocoder();
    //         myGeo.getLocation(new map.Point(res.point.lng, res.point.lat), function (result) {
    //           const params = Object.assign({
    //             lng: res.point.lng,
    //             lat: res.point.lat
    //           }, result.addressComponents)
    //           console.log(params);
    //           _this.clientPosition = params
    //         })
    //       }
    //     }, (err) => {
    //       console.log(err)
    //     })
    //   }
    // },
    async cutLocal() {
            let map = await this.load()
            let _this = this
            if (map.Map) {
                let funL = new map.Geolocation()
                funL.getCurrentPosition((res) => {
                    // 如果存在经纬度
                    if (res.point) {
                        var myGeo = new map.Geocoder();
                        myGeo.getLocation(new map.Point(res.point.lng, res.point.lat), function (result) {
                            const params = Object.assign({
                                lng: res.point.lng,
                                lat: res.point.lat
                            }, result.addressComponents)
                            console.log(params);
                            _this.clientPosition = params
                            //_this.formInline.Province = "10"
                            _this.formInline.Province = _this.alldata.province.filter(item => item.name == params.province)[0].id
                            _this.setCity(true);
                            // _this.formInline.City = "116"
                            _this.formInline.City = _this.alldata.city[_this.formInline.Province].filter(item => item.name == params.city)[0].id

                            _this.cityChange(_this.formInline.City)
                        })
                    }
                }, (err) => {
                    console.log(err)
                })
            }
        },

    // 定位城市
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript('//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize', function (res) {
            console.log("百度", res);
            let num = 1
            let time = setInterval(() => {
              if (BMap.Map) {
                this.BMap = true
                resolve(BMap)
                clearInterval(time)
              }
              num++
            }, 25)
          })
        } else {
          resolve(BMap)
        }
      })
    },
    distinctive(e) {
      this.isFullVideo = e
    },
    // 暂停四屏（Fourpage-AW-Middle）中的视频播放
    pauseFourpageVideos() {
      const fourpage = this.$refs.fourpageMiddle;
      if (fourpage) {
        if (typeof fourpage.pauseMainVideo === 'function') {
          fourpage.pauseMainVideo();
        }
        if (typeof fourpage.pauseExtraVideo === 'function') {
          fourpage.pauseExtraVideo();
        }
      }
    },
    setResize() {
      var that = this
      // document.getElementById("fullPageContainer").style.height = that.cHeight + 'px'
      // document.getElementById("page1").style.height = 'auto'
      // document.getElementById("page2").style.height = that.cHeight + 'px'
      // document.getElementById("page3").style.height = that.cHeight + 'px'
      // document.getElementById("page4").style.height = that.cHeight + 'px'
      //document.getElementById("page5").style.height = that.cHeight + 'px'
      // document.getElementById("page5").style.height =  '900px'
      // document.getElementById("page").style.height = that.cHeight + 'px'
    },
    forbid() {
      this.flag = true;
    },
    open() {
      this.flag = false;
    },
    custormAnchor(anchorName) {
      // window.location = "https://www.kia.cn/activity/2022/08/nq5cpay/7yhegE3/index.html#/?utm_source=&utm_soid=&utm_activity=&mz_ca=&mz_sp="
      this.directToMove(6);
      // // 找到锚点
      // let anchorElement = document.getElementById(anchorName);
      // // 如果对应id的锚点存在，就跳转到锚点
      // if(anchorElement) { anchorElement.scrollIntoView(); }
    },
    // 顶部 KV 区的锚点跳转，不再使用原有 directToMove，而是直接滚动到目标区块
    scrollAwSection(anchorName) {
      let selector = "";
      if (anchorName === "3") {
        // 回顾五代传奇 -> Extrathree，根元素 class="threepage"
        selector = ".threepage";
      } else if (anchorName === "4") {
        // 30 周年纪念版 -> TwoPageAW
        selector = this.isPortrait ? ".twopage" : ".twopage-pc";
      }
      if (!selector) {
        return;
      }
      const el = document.querySelector(selector);
      if (el) {
        // 头部有固定导航栏，需要预留空间：
        // PC 端 78px，MOB 端 60px
        const offset = this.isPortrait ? 60 : 78;
        const rect = el.getBoundingClientRect();
        const targetTop = rect.top + window.scrollY - offset;
        window.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });
      }
    },
    // 滚动到四屏 scroll_title 区域上方（供 KV 黑按钮使用）
    scrollToScrollTitle() {
      const selector = this.isPortrait ? ".scroll-title-mob" : ".scroll-title";
      const el = document.querySelector(selector);
      if (!el) return;
      const vw = window.innerWidth || document.documentElement.clientWidth || 1920;
      const offset1 = this.isPortrait ? (50 / 700) * vw : (60 / 1920) * vw;
      const offset = this.isPortrait ? 60 : 78;
      const rect = el.getBoundingClientRect();
      const targetTop = rect.top + window.scrollY - offset - offset1;
      window.scrollTo({
        top: targetTop,
        behavior: "smooth",
      });
    },
    getAngle(angx, angy) {
      return Math.atan2(angy, angx) * 180 / Math.PI;
    },
    //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
    getDirection(startx, starty, endx, endy) {
      let angx = endx - startx;
      let angy = endy - starty;
      let result = 0;

      //如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }

      let angle = this.getAngle(angx, angy);
      if (angle >= -135 && angle <= -45) {
        result = 1;
      } else if (angle > 45 && angle < 135) {
        result = 2;
      } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
        result = 3;
      } else if (angle >= -45 && angle <= 45) {
        result = 4;
      }

      return result;
    },
    getTouchstartY() {
      this.startY = event.changedTouches[0].pageY  //将手指对应的y轴坐标赋值给data中的startY
      this.startX = event.changedTouches[0].pageX
    },
    touchmove() {
      if (this.flag == true) {
        e.preventDefault()
      }
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        return false;
      }
      console.log('touch 123123')
      // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
      // event.preventDefault()
      let endx, endy;
      endx = event.changedTouches[0].pageX;
      endy = event.changedTouches[0].pageY;
      let direction = this.getDirection(this.startX, this.startY, endx, endy);
      switch (direction) {
        case 0:
          //alert("未滑动！");
          break;
        case 1:
          //alert("向上！")
          this.next()
          break;
        case 2:
          // alert("向下！")
          this.pre()
          break;
        case 3:
          //alert("向左！")
          break;
        case 4:
          //alert("向右！")
          break;
        default:
      }

    },
    next() {
      let len = this.totalPage;
      if (this.fullpage.current + 1 <= len) {
        this.fullpage.current += 1;
        this.move(this.fullpage.current);
      }
    },
    pre() {
      if (this.fullpage.current - 1 > 0) {
        this.fullpage.current -= 1;
        this.move(this.fullpage.current);
      }
    },
    move: throttle(function (index) {

      this.fullpage.isScrolling = true;
      this.directToMove(index);
      setTimeout(() => {
        this.fullpage.isScrolling = false;
      }, 800);

      let videos1 = document.querySelectorAll(".preview-video")[0];
      if (!videos1) {
        return
      }
      if (index == 2) {
        videos1.play();
      } else {
        videos1.pause();
      }
      // let videos2 = document.querySelectorAll(".full-video")[0];
      // if (!videos2 ) {
      //   return
      // }
      // if(!this.isFullVideo){
      //   return
      // }
      // if (index == 2) {
      //   videos2.play();
      // } else {
      //   videos2.pause();
      // }
    }, 800, true),
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight;
      let scrollPage = this.$refs["fullPageContainer"];
      // console.log(height)
      let scrollHeight;
      scrollHeight = -(index - 1) * height + "px";
      if (index === this.totalPage) {
        scrollHeight = -(index - 2) * height - this.$refs["footer"].clientHeight + "px";
      }
      scrollPage.style.transform = `translate3d(0,0,0) translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheel: throttle(function (event) {
      if (this.flag == true) {
        e.preventDefault()
      }
      console.log(123123, this.fullpage.isScrolling)
      let evt = event || window.event;
      if (evt.stopPropagation || evt.preventDefault) {
        evt.stopPropagation();
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail;
      if (this.fullpage.deltaY > 0) {
        this.next();
      } else if (this.fullpage.deltaY < 0) {
        this.pre();
      }
    }, 100, true),

  initData() {
    let that = this;
    this.$axios.get(CSMUrl).then((res) => {
      that.carAlldata = res.data;
    });
  },
  setProvince() {
    // this.formInline.City = "盐城市";
    // this.setCity(false);
    this.formInline.City = "";
    this.$set(this.formInline, 'DealerCode', '');
    this.$set(this.formInline, 'DealerName', '');
    this.cascadingDealers = [];
    this.setCity();
  },

  setCity(fromLocation = false) {
    //this.cascadingCities = this.alldata.city[this.formInline.Province];

    this.cascadingCities = [];
    // this.alldata.city[10].forEach((cityIter) => {
    const currentCities = this.alldata.city[this.formInline.Province] || [];
    currentCities.forEach((cityIter) => {
      //过滤city
      if (
        this.alldata.cityRelType[cityIter.id].includes("1") ||
        this.alldata.cityRelType[cityIter.id].includes("4")
      ) {
        this.cascadingCities.push(cityIter);
      }
    });
    if(!fromLocation){
      if(this.formInline.City){
        this.$set(this.formInline, 'City', this.formInline.City);
      }else{
        this.$set(this.formInline, 'City', this.cascadingCities.length ? this.cascadingCities[0].id : '');
      }
      // this.formInline.City = this.formInline.City || this.cascadingCities[0].id;
    }else{
      // #如果未找到对应城市数据(因为他没有经销商 所以alldata城市字典表中没这个城市),则默认选中第一个
      // this.formInline.City = this.cascadingCities.find((city) => city.name === this.clientPosition.city)?.id || this.cascadingCities[0].id
      if(!this.cascadingCities.find((city) => city.id === this.formInline.City)){
          // this.formInline.City = ''
          this.$set(this.formInline, 'City', '');
      }
    }
    this.cityChange(this.formInline.City);
  },
  async cityChange(cityId) {
    if (!cityId) {
      this.cascadingDealers = [];
      this.$set(this.formInline, 'DealerCode', '');
      this.$set(this.formInline, 'DealerName', '');
      return;
    }
    let map = await this.load();
    let baiduMap = new map.Map();
    //改变经销商数据/起点
    let temp = this.alldata.dealer[cityId] || [];
    this.cascadingDealers = [];
    temp.forEach((origin) => {
      if (origin.type == "1" || origin.type == "7") {
        // /**
        const originPosition = new BMap.Point(
          origin.latitude,
          origin.longitude
        );
        const nowPosition = new BMap.Point(
          this.clientPosition.lng,
          this.clientPosition.lat
        );
        //  **/
        this.cascadingDealers.push({
          ...origin,
          distance: this.getMapDistance(
           nowPosition,
           originPosition,
           baiduMap
          ),
          isDisabled: origin.isException === "是",
        });
      }
    });
    this.cascadingDealers = this.cascadingDealers.sort((a, b) => {
      // 首先处理 isException 的情况
      if (a.isException === "是" && b.isException !== "是") {
        return 1; // a 排在 b 后面
      } else if (a.isException !== "是" && b.isException === "是") {
        return -1; // b 排在 a 后面
      }
      return a.distance - b.distance;
    });
    // if (this.cascadingDealers.length) {
    //   this.formInline.DealerCode = this.cascadingDealers[0].code;
    //   this.formInline.DealerName = this.cascadingDealers[0].name;
    // }
    if (this.cascadingDealers.length) {
      this.$set(this.formInline, 'DealerCode', this.cascadingDealers[0].code);
      this.$set(this.formInline, 'DealerName', this.cascadingDealers[0].name);
    } else {
      this.$set(this.formInline, 'DealerCode', '');
      this.$set(this.formInline, 'DealerName', '');
    }
  },
  setCarSeries() {
    this.formInline.CarModelCMSID = "";
    console.log(
      "this.formInline.CarSeriesCMSID",
      this.formInline.CarSeriesCMSID
    );
    if (this.formInline.CarSeriesCMSID) {
      //  this.formInline.CarModelCMSID = this.carAlldata.model[this.formInline.CarSeriesCMSID].at(-1).cmsid;
      this.formInline.CarModelCMSID = this.carAlldata.model[this.formInline.CarSeriesCMSID][this.carAlldata.model[this.formInline.CarSeriesCMSID].length - 1].cmsid;
      //  this.formInline.CarModelName = this.carAlldata.model[this.formInline.CarSeriesCMSID].at(-1).name;
      this.formInline.CarModelName = this.carAlldata.model[this.formInline.CarSeriesCMSID][this.carAlldata.model[this.formInline.CarSeriesCMSID].length - 1].name
    }
    console.log('this.formInline.CarModelName', this.formInline.CarModelName);
  },
  getMapDistance(centerPoint, otherPoint, map) {
    let distance = map.getDistance(centerPoint, otherPoint);
    return (distance / 1000).toFixed(2);
  },
  dealerChange(dealerCode) {
    let dealer = this.cascadingDealers.find((value) => {
      return value.code === dealerCode;
    });
    this.formInline.DealerCode =
      dealer == null ? this.cascadingDealers[0].code : dealer.code;
    this.formInline.DealerName =
      dealer == null ? this.cascadingDealers[0].name : dealer.name;
  },
  submitInformation() {
    console.log(this.formInline);
    if (
      !this.formInline.Name ||
      !this.formInline.Phone ||
      !this.formInline.verificationCode ||
      !this.formInline.CarSeriesCMSID
    ) {
      this.$message.error("请完善信息后再次提交");
      return;
    }
    //获取车型名字
    // console.log(this.carSeries)
    let CarSeriesName = this.carAlldata.series.find((item, index) => {
      return item.cmsid === this.formInline.CarSeriesCMSID;
    });
    //获取默认经销商名字和编码
    if (!this.formInline.DealerCode || !this.formInline.DealerName) {
      this.formInline.DealerCode = this.cascadingDealers[0].code;
      this.formInline.DealerName = this.cascadingDealers[0].name;
    }
    //将省市转化成字符串
    let provinceStr = this.alldata.province.find(
      (item) => item.id === this.formInline.Province
    );
    let cityStr = this.alldata.city[this.formInline.Province].find(
      (item) => item.id === this.formInline.City
    );
    provinceStr = provinceStr.name;
    cityStr = cityStr.name;

    if (!this.formInline.checked) {
      this.$message.error("请先同意起亚及合作商就购买新车事宜与您联系您同意提供电话号码");
      return;
    }
    let subFormDrive = {
      //媒体来源、活动来源、媒体渠道ID没写
      CarBuyingTime: "-",
      carModelCmsid: this.formInline.CarModelCMSID,
      carModelName: this.formInline.CarModelName,
      carSeriesCmsid: this.formInline.CarSeriesCMSID,
      carSeriesName: CarSeriesName.name,
      cityName: cityStr,
      dealerCode: this.formInline.DealerCode,
      dealerName: this.formInline.DealerName,
      provinceName: provinceStr,
      userName: this.formInline.Name,
      userPhone: this.formInline.Phone,
      verificationCode: this.formInline.verificationCode,
      smartCode: getUrlKey("utm_source") || "官网", //媒体来源
      activity: getUrlKey("utm_activity") || "苏超活动-预约试驾", //活动名称
      extraSix: getUrlKey("utm_soid") || "76",
    };
    //预约试驾接口
    this.$axios
        .post(`${apiUrl}clue/australiaPage`, subFormDrive)
        .then((res) => {
      console.log(99999998888, res);
      if (res.data.success) {
        this.$message.success("预约试驾成功");
        console.log(subFormDrive);
        setTimeout(() => {
          this.formInline.CarModelCMSID = "";
          this.formInline.CarSeriesCMSID = "";
          this.formInline.DealerCode = "";
          this.formInline.DealerName = "";
          this.formInline.Name = "";
          this.formInline.Phone = "";
          this.formInline.verificationCode = "";
          this.formInline.City = "";
          this.formInline.Province = "";
          this.formInline.checked = false;
          // 重置倒计时
          window.clearInterval(this.clock);
          this.countDownContent = "获取验证码";
          this.totalTime = 60;
          this.countDownCanClick = true;
        }, 1000);
      } else {
        this.$message.error("预约试驾失败:" + res.data.message);
        console.log(subFormDrive);
        console.log(res.msg);
      }
    });
  },
  gotoBlock(e) {
    // console.log(e);
    // const el = this.$refs[`pc-block${e}`];
    var _that = this
    if (!this.isPortrait) {
      if (!this.isAnimating) {
        this.isAnimating = true;
        // 在动画结束后将 isAnimating 设置为 false，以便下次点击重新触发动画
        setTimeout(() => {
          this.isAnimating = false;
        }, 1000); // 假设动画持续 3 秒钟
      }
    } else {
    //   const el = this.$refs[`pc-block${e}`];
    //   el.scrollIntoView()
       var top =  this.page5Top;
    //    页面滚动到top距离
         window.scrollTo({
            top: top,
         });
      _that.showTopBtn = false
    }
  },
}
}

</script>

<style>
.my-select-style {
  z-index: 800 !important;
}
</style>
<style lang="scss" scoped>
.select-option-dealer .el-select-dropdown__item {
  height: auto !important;
  padding: 0 10px;
}
.el-select-dropdown__item.selected {
  font-weight: 500 !important;
}
.fullPage {
  padding: 0;
  margin: 0;
  /* height: calc(100vh); */
  /* overflow: hidden; */

  // background-color: #fff;
  // background-color: rgba(35, 107, 180, 1);
  color: #000000;
}

.fullPageContainer {
  width: 100%;
  /* height: calc(100vh); */
  transition: all ease-out 0.8s;
}

.section {
  width: 100%;
  // height: calc(100vh);
  @media (max-width:767px) {
    // height: calc(890 / 390 * 100vw);
    height: calc(2668 / 1500 * 100vw);
  }
  background-position: center center;
  background-repeat: no-repeat;
  /* transform: translate3d(0, 0, 0); */
  overflow: hidden;
}

.section5 {
  margin-top: -3px;
  /* background: #F6F3EE; */
  // background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/fourth-page-background-mob.png');
  // background-repeat: no-repeat;
  /* 防止重复 */
  // background-size: 100% 100%;
  background-size: cover;
}

.section6 {
  height: auto;
  background: #000000;
}

.oneform {
  background-color: rgb(255, 255, 255, 0.7);
  text-align: center;
  padding-top: 10px;
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 100;
}

.animate {
  animation: heightAni 1s ease-in-out forwards;
  /* 假设动画持续 3 秒钟 */
}

// ::v-deep .el-input__inner {
//   background-color: rgb(255, 255, 255, 0.7) ;;
//   border-radius: unset;
//   color: #fff;

//   &::placeholder {
//     color: rgb(148 148 149);
//   }
// }
.tips {
  font-size: calc(16 / 2200 * 100vw);
    // color: #FFFFFF99;
    // text-align: left;
    // display: flex;
}
.inbox {
  width: calc(178 / 1920 * 100vw);
  margin-bottom: 10px;
}
.inboxinput > ::v-deep.el-input__inner{
  background-color: rgb(255, 255, 255, 0.7) ;
  border-radius: unset;
  color: #000000;

  &::placeholder {
    color: rgb(148 148 149);
  }
}

.inboxinput > ::v-deep.el-input> .el-input__inner{
  background-color: rgb(255, 255, 255, 0.7) ;;
  border-radius: unset;
  color: #000000;

  &::placeholder {
    color: rgb(148 148 149);
  }
}
::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #19191C, $alpha: 0.3);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19191C;
  border-color: #19191C;
}

.yy-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  z-index: 1000;
  img {
    width: 24px;
    margin-bottom: 20px;
    animation: tbmove 0.7s infinite;
    // height: ;
  }

  &-btn {
    width: 80%;

    button {
      width: 100%;
      height: 43px;
      //border-radius: 24px;
      // background-color: rgba(57, 67, 75, 1);
      background-color: #000;
      color: #fff;
      border: none;
      // border-bottom: 3px solid rgba(215, 246, 56, 1);
      // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
    }
  }
}
</style>
